import { render, staticRenderFns } from "./Reportage.vue?vue&type=template&id=89c057dc&scoped=true"
import script from "./Reportage.vue?vue&type=script&lang=js"
export * from "./Reportage.vue?vue&type=script&lang=js"
import style0 from "./Reportage.vue?vue&type=style&index=0&id=89c057dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c057dc",
  null
  
)

export default component.exports